import { render } from "./AppWrapper.vue?vue&type=template&id=617d3aeb"
import script from "./AppWrapper.vue?vue&type=script&lang=js"
export * from "./AppWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/AppWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "617d3aeb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('617d3aeb', __exports__)) {
    api.reload('617d3aeb', __exports__)
  }
  
  module.hot.accept("./AppWrapper.vue?vue&type=template&id=617d3aeb", () => {
    api.rerender('617d3aeb', render)
  })

}


export default __exports__